var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ImageGallery component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconImageGallery extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.41526 4.16591C3.20023 4.16591 2.99401 4.25133 2.84196 4.40338C2.68991 4.55543 2.60449 4.76165 2.60449 4.97668V16.6824C2.60449 17.0967 2.26871 17.4324 1.85449 17.4324C1.44028 17.4324 1.10449 17.0967 1.10449 16.6824V4.97668C1.10449 4.36382 1.34795 3.77607 1.7813 3.34272C2.21465 2.90936 2.80241 2.66591 3.41526 2.66591H17.4622C17.8764 2.66591 18.2122 3.0017 18.2122 3.41591C18.2122 3.83012 17.8764 4.16591 17.4622 4.16591H3.41526ZM21.3156 19.3731C21.3662 19.2672 21.3945 19.1487 21.3945 19.0236V8.8786C21.3945 8.43082 21.0315 8.06783 20.5838 8.06783H7.31722C6.86945 8.06783 6.50645 8.43082 6.50645 8.8786V19.0236C6.50645 19.1769 6.54899 19.3202 6.62289 19.4425L12.2773 13.4716C12.491 13.2383 12.7504 13.0515 13.0393 12.9226C13.3308 12.7925 13.646 12.7243 13.9651 12.7221C14.2842 12.7199 14.6003 12.7839 14.8935 12.9099C15.1854 13.0355 15.4483 13.2198 15.6657 13.4515L21.3156 19.3731ZM21.743 21.023C22.4315 20.6229 22.8945 19.8773 22.8945 19.0236V8.8786C22.8945 7.60239 21.86 6.56783 20.5838 6.56783H7.31722C6.04102 6.56783 5.00645 7.60239 5.00645 8.8786V19.0236C5.00645 19.9355 5.5347 20.7241 6.30189 21.0999C6.36121 21.1362 6.4244 21.1635 6.48952 21.1817C6.74648 21.2803 7.02554 21.3344 7.31722 21.3344H20.5838C20.9046 21.3344 21.2103 21.269 21.488 21.1508C21.5784 21.1255 21.6651 21.083 21.743 21.023ZM19.6825 19.8344L14.573 14.4791C14.4965 14.3973 14.4039 14.3322 14.3011 14.288C14.1982 14.2438 14.0873 14.2213 13.9753 14.2221C13.8633 14.2228 13.7527 14.2468 13.6505 14.2924C13.5482 14.338 13.4565 14.4043 13.3812 14.4872L13.371 14.4981L8.31762 19.8344H19.6825Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconImageGallery.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconImageGallery.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconImageGallery.prototype, "size", void 0);
if (customElements.get('cat-icon-image-gallery') === undefined) {
    customElements.define('cat-icon-image-gallery', BlocksIconImageGallery);
}
